import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const ArticlePage = lazy(
  () =>
    import('./ArticlePage.eager').then(mod => ({
      default: mod.ArticlePage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
